import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { c as m } from "../../index-C7ezJk5b.js";
import { useState as d, useRef as f } from "react";
import { AppId as u } from "../../core/models/PlatformNavigation.js";
import { b as g } from "../../base-nYmjnkiN.js";
import P from "../../core/hooks/useOutsideClick.js";
import { cssX as r, cssTI as N } from "../../core/utils/css.js";
import "react-dom";
import h from "../../components/ProductLogo/ProductLogo.js";
import v from "../../components/Wrapper/Wrapper.js";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
import _ from "./SnapSearch.js";
import I from "./HelpCenter.js";
import S from "./UserMenu.js";
import { NavigationProducts as b } from "./NavigationProducts.js";
import x from "../GlobalSearch/GlobalSearch.js";
const X = ({
  style: s,
  className: n,
  testId: p
}) => {
  const [e, a] = d(!1), i = f(null);
  P({
    ref: i,
    callback: () => a(!1)
  });
  const {
    userInfo: {
      snapUiUrl: l,
      injectedCss: c
    }
  } = g();
  return /* @__PURE__ */ t(
    "div",
    {
      className: m(
        r("PlatformNavigation"),
        n,
        e && r("PlatformNavigation--more-products-opened")
      ),
      style: s,
      "data-testid": p,
      children: [
        /* @__PURE__ */ o("style", { dangerouslySetInnerHTML: { __html: c } }),
        /* @__PURE__ */ t(v, { children: [
          /* @__PURE__ */ t("div", { className: r("PlatformNavigation__inner"), children: [
            /* @__PURE__ */ o(
              "a",
              {
                className: m(r("PlatformNavigation__logo"), r("Icon")),
                href: l,
                "data-testid": N("button", "PlatformNavigationLogo"),
                children: /* @__PURE__ */ o(
                  h,
                  {
                    appId: u.Snap,
                    style: { width: "100%" }
                  }
                )
              }
            ),
            /* @__PURE__ */ t("div", { className: r("PlatformNavigation__right"), children: [
              /* @__PURE__ */ o(_, {}),
              /* @__PURE__ */ o(I, {}),
              /* @__PURE__ */ o(S, {})
            ] }),
            /* @__PURE__ */ o(
              b,
              {
                moreProductsButtonRef: i,
                isMoreProductsDropdownOpened: e,
                setIsMoreProductsDropdownOpened: a
              }
            )
          ] }),
          /* @__PURE__ */ o(x, {})
        ] })
      ]
    }
  );
};
export {
  X as PlatformNavigation
};
